import { VERBOSE_INSIDER_BENEFIT_LABELS_240311 } from "@faire/web-api/indigofair/settings/VERBOSE_INSIDER_BENEFIT_LABELS_240311";

import { getSettingValueWithoutAssignment } from "@faire/retailer/settings/__internal__/getSetting";

export const getSettingValueOnlyVerboseInsiderLabels = (): boolean =>
  getSettingValueWithoutAssignment(
    VERBOSE_INSIDER_BENEFIT_LABELS_240311,
    false
  );
